module.exports = fox._r("images/scene_preload.gif", __webpack_public_path__ + "_/_/_/root/images/scene_preload.gif");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/images/scene_preload.gif
// module id = 6
// module chunks = 4